/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Welcome_Landing_Browsedescription1Inputs */

const en_welcome_landing_browsedescription1 = /** @type {(inputs: Welcome_Landing_Browsedescription1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explore available ${i?.companyName} funds for future investments`)
};

/**
* | output |
* | --- |
* | "Explore available {companyName} funds for future investments" |
*
* @param {Welcome_Landing_Browsedescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_landing_browsedescription1 = /** @type {((inputs: Welcome_Landing_Browsedescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Landing_Browsedescription1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_landing_browsedescription1(inputs)
});
export { welcome_landing_browsedescription1 as "welcome_landing_browseDescription" }